import React, { Component } from "react";
import "antd/dist/antd.css";
import { Row, Col, Button } from "antd";
import Orderconfirmimg from "../../Images/confirmorder.png";
// import conversation from '../../Images/conversation.png';
import headphones from "../../Images/headphones.png";
import { Link } from "react-router-dom";

class Orderconfirm extends Component {
  render() {
    return (
      <div>
        <Row style={{ textAlign: "center", padding: "50px" }}>
          <img src={Orderconfirmimg} alt="" />
          <h3
            className="Docheading"
            style={{ fontSize: "30px", lineHeight: "30px", paddingTop: "40px" }}
          >
            Your order is confirmed!
          </h3>
          {/* <p className="Docpara" style={{fontSize:'17px', color:'#7B8190'}}>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam</p>  */}
          <Link to={"/app/orders/orderdetails/" + this.props.match.params.id}>
            <Button className="orderbtn">Track Order</Button>
          </Link>
        </Row>
        <Row
          style={{ paddingLeft: "30%", paddingRight: "15%", marginTop: "4%" }}
        >
          {/* <Col lg={12} md={12} sm={24} xs={24}>
                <div style={{width:'500px',backgroundColor:'white', padding:'20px'}}>
                   <Row>
                     <Col lg={8} md={8} sm={24} xs={24}>
                       <div className="Faqdiv">
                        <img src={conversation} alt="" />
                        </div>
                     </Col>
                     <Col lg={16} md={16} sm={24} xs={24}>
                        <h3  className="Docheading"style={{fontSize:'30px', lineHeight:'30px', paddingTop:'40px'}} >FAQ</h3>
                        <p className="Docpara" style={{fontSize:'17px', color:'#7B8190'}}>Maybe we’ve already answered your question. Here’s our FAQs</p>
                     </Col>
                   </Row>
                </div>
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} >
                <div style={{width:'500px',backgroundColor:'white', padding:'20px'}}>
                  <Row>
                    <Col lg={8} md={8} sm={24} xs={24}>
                    <div className="Faqdiv">
                    <img src={headphones} alt="" />
                    </div>
                    </Col>
                    <Col lg={16} md={16} sm={24} xs={24}>
                      <h3  className="Docheading"style={{fontSize:'30px', lineHeight:'30px', paddingTop:'40px'}} >Call Us</h3>
                      <p className="Docpara" style={{fontSize:'17px', color:'#7B8190'}}>Get help with our awesome Customer Support team to resolve your queries.</p>
                    </Col>
                  </Row>
                </div>
              </Col> */}
          <Col lg={18} md={18} sm={24} xs={24}>
            <div
              style={{
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "10px",
              }}
            >
              <Row>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <div className="Faqdiv">
                    <img src={headphones} alt="" />
                  </div>
                </Col>
                <Col lg={16} md={16} sm={24} xs={24}>
                  <h3
                    className="Docheading"
                    style={{
                      fontSize: "30px",
                      lineHeight: "30px",
                      paddingTop: "40px",
                    }}
                  >
                    Contact Us
                  </h3>
                  <p
                    className="Docpara"
                    style={{ fontSize: "17px", color: "#7B8190" }}
                  >
                    Please contact us at{" "}
                    <a href="mailto:office@defeomaterials.com">
                      office@defeomaterials.com
                    </a>{" "}
                    for any further queries.
                  </p>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
export default Orderconfirm;
